import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { TOOLTIP_INITIALVALUE, TOOLTIP_VALIDATION, TOOLTIP_VALIDATIONSCHEMA } from "../../../../Data/FormControl/FormValidation";
import { FormValidationTooltip } from "../../../../Constant";
import { Formik } from "formik";
import { TooltipValidationForm } from "./TooltipValidationForm";
import { TooltipValidationProp } from "../../../../Type/FormValidation";
import { useState } from "react";

const TooltipFormValidation = () => {
  const [submitErrors, setSubmitError] = useState<boolean>(false);

  const submitHandler = (values: TooltipValidationProp, { resetForm }: { resetForm: () => void }) => {
    resetForm();
    setSubmitError(false);
  };

  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={FormValidationTooltip} span={TOOLTIP_VALIDATION} />
        <CardBody>
          <Formik initialValues={TOOLTIP_INITIALVALUE} onSubmit={submitHandler} validationSchema={TOOLTIP_VALIDATIONSCHEMA}>
            {({ errors }) => <TooltipValidationForm errors={errors} setSubmitError={setSubmitError} submitErrors={submitErrors} />}
          </Formik>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TooltipFormValidation;
